import React from "react"
import { Cell } from "fixed-data-table-2"
import sheetConstants from "sheets/constants"
import { Repeat } from "immutable"
import Tooltip from "app/static/frontend/components/Tooltip"
import PropTypes from "prop-types"
import classNames from "classnames"

// These are used to figure out how many people to render based on the size
// of the cell without having to make calls to calculateTextWidth, which would
// be expensive if we're calling it multiple times per cell.
const PEOPLE_TO_RENDER_FACTOR = 1/250
const PEOPLE_TO_RENDER_ADDEND = -80

const ClickablePerson = ({person}) => (
    <a href={person.get("profile_url")}>
        {person.get("name")}
    </a>
)

export class CustomDataPersonsCell extends React.Component {
    getLabel() {
        return this.props.cellValue.map(p => p.get("name")).join(", ")
    }

    getNumberOfPeopleToRender() {
        if (this.props.cellValue.size < 1) {
            return 0
        }

        let maxCharacters = (
            PEOPLE_TO_RENDER_FACTOR
                * this.props.height
                * this.props.width
            + PEOPLE_TO_RENDER_ADDEND
        )
        let peopleToRender = 1;
        let characters = this.props.cellValue.get(0).get("name").length
        for (let i=1;i<this.props.cellValue.size;i++) {
            characters += this.props.cellValue.get(i).get("name").length
            if (characters > maxCharacters) return peopleToRender
            peopleToRender++
        }
        return peopleToRender
    }

    renderClickablePersons(peopleToRender) {
        if (peopleToRender < 1) {
            return ""
        } else {
             return this.props.cellValue.slice(0, peopleToRender).map(
                 (p, i) => <ClickablePerson key={i} person={p} />
             ).interleave(Repeat(", ")).slice(0,-1)
        }
    }

    renderMoreIndicator(peopleToRender) {
        return `... (${this.props.cellValue.size - peopleToRender} more)`
    }

    render() {
        const peopleToRender = this.getNumberOfPeopleToRender()
        const doesPeopleOverflow = peopleToRender < this.props.cellValue.size
        
        return (
            <Tooltip
                delayShow={this.props.delayShow}
                label={this.getLabel()}
                placement={this.props.placement}
            >
                <Cell
                    {...this.props}
                    className={classNames(
                        this.props.className,
                        "large-text-cell-overflow-hidden",
                        `large-text-cell-${this.props.rowHeightFactor || 1}`
                    )}
                >
                    { this.renderClickablePersons(peopleToRender) }
                    { doesPeopleOverflow && this.renderMoreIndicator(peopleToRender) }
                </Cell>
            </Tooltip>
        )
    }
}

CustomDataPersonsCell.propTypes = {
    delayShow: PropTypes.number,
    editing: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool,
    placement: PropTypes.string,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,

    // Should be an ImmutableJS list
    cellValue: PropTypes.object.isRequired
}

CustomDataPersonsCell.defaultProps = {
    delayShow: sheetConstants.CELL_TOOLTIP_DELAY,
    placement: "left"
}

export default CustomDataPersonsCell
